import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PreferConditionsFormType, PreferTabType } from '@components/profile/profileOverlay/overlays/prefer/index';

import ProfileConditionsFormVO from '@domain/vo/profile/ProfileConditionsFormVO';
import classnames from 'classnames/bind';
import styles from './prefer.module.scss';

const cx = classnames.bind(styles);

interface IPreferTab {
  selectedTabType: PreferTabType;
  setSelectedTabType: (selectedTab: PreferTabType) => void;
}

const PreferTab = ({ selectedTabType, setSelectedTabType }: IPreferTab) => {
  const {
    formState: { isSubmitted, errors },
  } = useFormContext<ProfileConditionsFormVO>();

  const isOn = (tabType: PreferTabType | null) => tabType === selectedTabType;
  const isError = (checkFields: PreferConditionsFormType) => Object.keys(errors).includes(checkFields) && isSubmitted;

  return (
    <div className={cx('tabArea')}>
      <a
        // [D] 선택된 탭은 'on' 클래스 / 에러인 경우 'error' 클래스 추가
        className={cx('tab', { on: isOn('jobGroup') }, { error: isError('jobGroups') })}
        role="button"
        onClick={() => setSelectedTabType('jobGroup')}
      >
        희망 직군·직무
      </a>
      <a
        className={cx('tab', { on: isOn('location') }, { error: isError('locations') })}
        role="button"
        onClick={() => setSelectedTabType('location')}
      >
        희망 근무 지역
      </a>
      <a
        className={cx('tab', { on: isOn('salary') }, { error: isError('salary') })}
        role="button"
        onClick={() => setSelectedTabType('salary')}
      >
        희망 연봉수준
      </a>
      <a
        className={cx('tab', { on: isOn('welfare') }, { error: isError('welfareKeywords') })}
        role="button"
        onClick={() => setSelectedTabType('welfare')}
      >
        희망 복지혜택
      </a>
    </div>
  );
};

export default PreferTab;
